/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notificationcenter_Close1Inputs */

const en_notificationcenter_close1 = /** @type {(inputs: Notificationcenter_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close notifications`)
};

/**
* | output |
* | --- |
* | "Close notifications" |
*
* @param {Notificationcenter_Close1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const notificationcenter_close1 = /** @type {((inputs?: Notificationcenter_Close1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notificationcenter_Close1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notificationcenter_close1(inputs)
});
export { notificationcenter_close1 as "notificationCenter_close" }